import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../../../utils/theme';

type ParagraphColor = 'light' | 'dark';

const colorMap: Record<ParagraphColor, string> = {
  light: theme.landing.colors.light,
  dark: theme.landing.colors.primary,
};

interface ParagraphProps {
  text?: string;
  textWithStrong?: React.ReactNode;
  color?: ParagraphColor;
  justification?: 'left' | 'center' | 'right';
  maxWidth?: string;
  className?: string;
  id?: string;
}

export const Paragraph: React.FC<ParagraphProps> = ({
  text,
  textWithStrong,
  color = 'dark',
  justification = 'center',
  maxWidth = '100%',
  className,
  id,
}) => {
  if (text) {
    return (
      <Text
        className={className}
        color={colorMap[color]}
        justification={justification}
        maxWidth={maxWidth}
        dangerouslySetInnerHTML={{ __html: text }}
        id={id}
      />
    );
  }

  return (
    <Text color={colorMap[color]} justification={justification} maxWidth={maxWidth}>
      {textWithStrong}
    </Text>
  );
};

interface StyledTextProps {
  color: string;
  justification?: 'left' | 'center' | 'right';
  maxWidth?: string;
}

const Text = styled.p<StyledTextProps>`
  color: ${({ color }) => color};
  font-family: 'League Spartan', sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  max-width: ${({ maxWidth }) => maxWidth} !important;
  text-align: ${({ justification }) => justification || 'center'};
  overflow-wrap: break-word;

  @media (min-width: 768px) {
    font-size: 25px;
    line-height: 30px;
  }

  strong {
    font-weight: 700;
  }

  & span {
    font-size: 30px;
    display: inline-block;
    margin: 10px 0;

    @media (min-width: 768px) {
      font-size: 50px;
    }
    @media (min-width: 1024px) {
      font-size: 65px;
      margin: 15px 0;
    }
  }
`;
